import Vue from "vue";
import Constants from "@/plugins/constants";
Vue.use(Constants);
import store from "@/store";
import {
  changeGeneralLocalStorageVariables,
  getLocalStorageValueByKey,
  removeGeneralLocalStorageVariables
} from "@/helpers/common";
import * as Sentry from "@sentry/browser";
import { encrypt } from "@/helpers/crypto-js";
import { localStorageKeys } from "@/enums/common";
const vueInstance = new Vue();


async function handleTokenExpire() {
  const jwtExpirationTime = getLocalStorageValueByKey(localStorageKeys.jwtExpirationTime);
   const currentTimestamp = Math.floor(Date.now() / 1000);

  if (currentTimestamp > jwtExpirationTime) {
    const oldJwt = getLocalStorageValueByKey(localStorageKeys.jwt);
    await setNewJwt();

    if (oldJwt == getLocalStorageValueByKey(localStorageKeys.jwt) || !getLocalStorageValueByKey(localStorageKeys.jwt)) {
       return removeSessionData();
    }
  }
}


async function setNewJwt() {
  const jwtSessionKey = getLocalStorageValueByKey(localStorageKeys.jwtSessionKey);

  if (!jwtSessionKey) return;

  try {
    const url = "authentication/web-app-obtain-encrypted-token";
    const config = {
      withCredentials: true,
      params: {
        "sessionKey": jwtSessionKey
      }
    };

    const response = await vueInstance.$constants('$http').get(url, config);
    return handleJwtAPIResponse(response);

  } catch (error) {
    Sentry.captureException(error);
  }
}

async function handleNewSession(next) {
  await setUserInformation();
  const email = store.getters["auth/getUserInformation"].email;

  if (!email) {
    next({ name: 'login' });

    return;
  }

  amplitude.getInstance().setUserId(email);
  Sentry.setUser({ email: email });


  changeGeneralLocalStorageVariables({
    key: localStorageKeys.newSession,
    value: getCookie("register") ? 'register' : 'login'
  });

  if (getCookie("register")) {
    deleteCookie("register", "/", ".heybooster.ai");
  }
}


async function setUserInformation(retry = 1) {
  const maxRetry = 3;

  if (retry > maxRetry) {
    removeSessionData();

    return;
  }

  try {
    const url = "/start";
    const response = await vueInstance.$constants('axios').get(url);
    const plainUserData = response.data;

    changeGeneralLocalStorageVariables({
      key: localStorageKeys.user,
      value: encrypt(plainUserData, true)
    });

    store.commit('auth/setUserInformation', getLocalStorageValueByKey(localStorageKeys.user));

  } catch (e) {
    return setUserInformation(retry + 1);
  }
}

function jwt() {
  return getLocalStorageValueByKey(localStorageKeys.jwt);
}


function removeSessionData() {
  changeGeneralLocalStorageVariables({
    removeKey: true,
    key: localStorageKeys.jwt
  });
  changeGeneralLocalStorageVariables({
    key: localStorageKeys.logout,
    value: true
  });

  removeGeneralLocalStorageVariables();
}

function isOnboardingCompleted(){
  return store.getters["auth/getUserInformation"].isOnboardingCompleted;
}



function setCookie(name, value, time) {
  let expires = "";

  if (time) {

    const date = new Date();
    date.setTime(date.getTime() + time);
    expires = `; expires=${date.toGMTString()}`;

  }

  document.cookie = `${name}=${value};${expires};path=/`;
}

function getCookie(cookie_value) {
  var name = cookie_value + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return false;
}

function deleteCookie(name, path="/", domain) {
  if (getCookie(name)) {

    document.cookie =
      name +
      "=" +
      (path ? ";path=" + path : "") +
      (domain ? ";domain=" + domain : "") +
      ";expires=Thu, 01 Jan 1970 00:00:01 GMT";

  }
}

function setInitialAxiosCancelToken(){
  store.commit('common/setAxiosCancelToken');
}

function setRedirectUrl(path) {
  if (path) {
    const cleanPath = String(path).replace(/\//g, '')

    changeGeneralLocalStorageVariables({
      key: localStorageKeys.redirectURL,
      value: cleanPath
    });
  }
}

function getRedirectUrl() {
  if (getLocalStorageValueByKey(localStorageKeys.redirectURL)) {

    return getLocalStorageValueByKey(localStorageKeys.redirectURL).replaceAll('//', '');

  }
}

function sendGoogleTagManagerEvent() {
  dataLayer.push({
    'event': 'page_view'
  });
}

function parseJwt(token) {
  var base64Url = token.split(".")[1];
  var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  var jsonPayload = decodeURIComponent(
    atob(base64)
      .split("")
      .map(function(c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join("")
  );
  return JSON.parse(jsonPayload);
}

async function handleJwtAPIResponse(response){
  if (!response?.status) return;

  if (response?.data?.action == 'logout') {
    return removeSessionData();
  }

  if (response?.status == "pending") {
    const delay = (duration) => new Promise(resolve => setTimeout(resolve, duration));
    await delay(1000);

    return setNewJwt();
  }

  if (response?.data?.jwt) {

    changeGeneralLocalStorageVariables({
      key: localStorageKeys.jwt,
      value: response.data.jwt
    })

    changeGeneralLocalStorageVariables({
      key: localStorageKeys.jwtExpirationTime,
      value: response.data.exp
    })
  }
}

export {
  parseJwt,
  jwt,
  handleTokenExpire,
  isOnboardingCompleted,
  setInitialAxiosCancelToken,
  getRedirectUrl,
  setRedirectUrl,
  sendGoogleTagManagerEvent,
  setCookie,
  getCookie,
  deleteCookie,
  setUserInformation,
  handleNewSession,
  setNewJwt
}



// WEBPACK FOOTER //
// ./src/helpers/main/index.js